import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/questionnaire/task/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/questionnaire/task/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/questionnaire/task/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/questionnaire/task/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/questionnaire/task/submit', params,options);

export const createTaskByPlanId = (params, options) =>
  request.post('/api/v4ward/questionnaire/task/createTaskByPlanId', params,options);
export const getTopicList = (params, options) =>
  request.get('/api/v4ward/questionnaire/task/topicList', Object.assign({}, options, { params }));

